import { render } from "./NotificationRibbon.vue?vue&type=template&id=68ea8022"
import script from "./NotificationRibbon.vue?vue&type=script&lang=js"
export * from "./NotificationRibbon.vue?vue&type=script&lang=js"

import "./NotificationRibbon.vue?vue&type=style&index=0&id=68ea8022&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__